import axios from 'axios';
import { api } from './axios';
import { select } from '@wordpress/data';
import { store } from '../../redux/store';
import { getWpnonce } from '../actions/action';

const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'wpnonce': await getWpnonce()
}

export const saveLogRequest = (data) => {
    let log = {};
    if (data?.response?.data?.message)
        log.message = data?.response?.data?.message;
    else
        log.message = data?.message;

    log.exception = data?.response?.status
    log.exception_name = data?.code
    log.function_name = data?.response?.config?.url
    log.priority = data?.response?.status == 401 ? 2 : 1

    axios.post(`/wp-admin/admin-ajax.php?action=save_log`,
        new URLSearchParams(log)?.toString(),
        { headers }).then(async (data) => {
            if (data?.data?.data?.logSalvo && log.priority == 1) {
                const id = select(store).getBlogIdOpti();
                log.message += ` / idBlog: ${id}`
                api.post(`/monitoramento/salvar-log`, {
                    data: new Date(),
                    excecao: log.exception?.toString(),
                    mensagem: log.message,
                    nomeExcecao: log.exception_name,
                    nomeFuncao: log.function_name
                });
            }
        })
    
}